import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from "./stores";
import {createTheme, ThemeProvider} from "@mui/material";
import {BrowserRouter} from "react-router-dom";
import {LocalizationProvider} from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en';

const theme = createTheme({
    palette: {
        primary: {
            // Purple and green play nicely together.
            main: '#006225',
        },
        secondary: {
            // This is green.A700 as hex.
            main: '#00b946',
        },
        disabledButton: {
            main: '#CCCCCC'
        }
    },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

      <Provider store={store}>
          <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                  <BrowserRouter>
                    <App />
                  </BrowserRouter>
              </LocalizationProvider>
          </ThemeProvider>
      </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
